import { Box } from '@mui/material';
import { PersonalUserStandardContanier } from 'modules/Users';
import { useParams } from 'react-router-dom';

type Props = {};

const PersonalUserStandard = (props: Props) => {
  const { userType } = useParams();
  return <PersonalUserStandardContanier />;
};

export default PersonalUserStandard;
